import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
// import { Link }
import {Container, Button} from 'reactstrap';

import NotFoundImg from '../../images/dashboard-empty-state.png';
export default class NotFound extends Component{
    render(){
        return(
            <Container className="page-container">
                <div style={{flex:1}}>
                    <div className="not-found">
                      <div className="img-wrapper">
                        <div className="text-wrapper">
                          <p>Oh snap, we can't find it!</p>
                          <p className="text-center">It seems like we do not have what you are looking for. Yet.</p>
                        </div>
                        <KickImage src={NotFoundImg}/>
                      </div>
                      <div className="button-wrapper">
                        <Button href="/" className="btn-black flat spacer">Back to Home Page</Button>
                      </div>
                        {/* <h1 className="text-center">404 Not Found</h1>
                        <h5 className="text-center">Laman web tidak ditemukan.</h5> */}
                    </div>
                </div>
            </Container>
        )
    }
}